import { render } from "./App.vue?vue&type=template&id=5ebd2f4f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5ebd2f4f&lang=scss"
script.render = render

export default script